import { render, staticRenderFns } from "./CheckFitsModal.vue?vue&type=template&id=dae6b6f8&lang=pug&"
import script from "./CheckFitsModal.vue?vue&type=script&lang=js&"
export * from "./CheckFitsModal.vue?vue&type=script&lang=js&"
import style0 from "./CheckFitsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports